import styled from 'styled-components';
import { buttonShadow, colors, fontSizes, fontWeights, smallShadow, spacing } from 'ui/theme';
import { IconButton } from 'ui/button';
import { pxToRem } from 'utils/convert';
import { INSIGHT_PANEL_SIZES } from 'modules/segmentation/constants';

export const InsightPanelHeader = styled.div`
  font-size: ${fontSizes.s14};
  font-weight: ${fontWeights.semiBold};
  color: ${colors.textSecondary};
  flex-grow: 0;
  max-width: [data-width];
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const InsightPanelHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: ${pxToRem(52)};
  margin: 0 -${spacing.base} 0 -${spacing.plusHalf};
  [data-size=${INSIGHT_PANEL_SIZES.small}] {
    height: min-content;
  }
  [data-divider='true'] {
    border-bottom: ${spacing.single} solid #bdbdbd;
  }
  padding: 0 ${spacing.base} ${spacing.base} ${spacing.plusHalf};
`;

export const InsightPanelWrapper = styled.div`
  background-color: ${colors.backgroundPrimary};
  border-radius: ${spacing.half};
  border: ${spacing.single} solid #d6d6d6;
  display: flex;
  flex-direction: column;
  padding: ${spacing.base} ${spacing.base} ${spacing.base} ${spacing.plusHalf};
  ${smallShadow};

  &[data-custom='true'] {
    animation: fadeIn 1.5s;
    animation-timing-function: cubic-bezier(0, 0, 0.34, 0.95);
    transition-duration: 1.5s;

    @keyframes fadeIn {
      0%,
      25% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }
  }
`;

export const CustomPanelWrapper = styled(InsightPanelHeaderWrapper)`
  grid-template-columns: [title] 1fr [delete] min-content;
`;

export const CustomInsightRemovalMenuButton = styled(IconButton)`
  ${buttonShadow};
`;
